// extracted by mini-css-extract-plugin
export default {"root":"ConfirmModal_root__NXzrF","titleContainer":"ConfirmModal_titleContainer__inlI5","buttons":"ConfirmModal_buttons__X+Ah7"};